<template>
	<div class="superbowl dexcom" v-if="pageSuperbowl.elements">
		<!-- content home -->
		<hero :props="pageSuperbowl.elements"  :heroHome="false"></hero>

		<section class="main-content" v-in-viewport="">
			<div class="inside text-center">
				<h1 class="main-title">{{pageSuperbowl.elements.title_content.value}}</h1>
				<div class="description" v-html="pageSuperbowl.elements.main_content.value">
				</div>
			</div>
		</section>

		<!-- Technologies Cases Slider -->
		<section class="content-section video" v-in-viewport="" v-if="pageSuperbowl.elements != undefined">
				<!-- <slider :props="sliders"></slider> -->			
				<div class="video-content" v-if="pageSuperbowl.elements.video_url.value != undefined">					
					<video controls :poster="pageSuperbowl.elements.poster_url.value[0].url"  v-if="pageSuperbowl.elements.poster_url.value != ''">
						<source :src="pageSuperbowl.elements.video_url.value">
					</video>
					<video v-else controls preload="metadata">
						<source :src="pageSuperbowl.elements.video_url.value">
					</video>
				</div>				
		</section>

		<!-- Contact Form  -->
		<contact :contactFormInfo="contactFormInfo"></contact>

		<div class="clearfix"></div>
		
		<!-- Footer -->
		<Footer></Footer>
	</div>
</template>


<script>
	import seoModule from '../mixins/seoModule.js';
	import contactForm from '../components/contact-form-about.vue';
	import hero from '../components/hero-wysiwyg.vue';
	import Footer from '../layout/footer-component.vue';
	import slider from '../components/slider-video.vue';

	require('../assets/img/about.png');

	export default{
		name:'Dexcom',
		data () {
			return {
				pageSuperbowl: [],
				modularContent:[],
				contactFormInfo: [],
				sliders:[],

			}
		},
		created:function(){
			//document.body.classList.add("healtcare");
			this.loadDexcomMagicMomentsData();

			setTimeout(function(){
				var x = $('.VueCarousel-dot-container').width();
				$('.VueCarousel-navigation-prev').css('left','calc(50% - '+ ((x/2)+20)+'px )');
				$('.VueCarousel-navigation-next').css('right','calc(50% - '+ ((x/2)+20) +'px )');


				if( $('.VueCarousel-dot-container').children().length < 2 ){
					$('.VueCarousel-navigation').hide();
				}
				else {
					$('.VueCarousel-navigation').show();
				}


			},1500);
		},
		mounted: function() {
			setTimeout(function(){
				$('.st-sticky-share-buttons').removeClass('st-sticky-share-buttons-show')
			},500);
		},
		methods: {
			loadDexcomMagicMomentsData() {
				this.$http.get("/src/data_jsons/dexcom_magic_moments_data.json").then((response) => {
					if (response.body.items.length == 0) {
						this.$router.push("404");
					}

					let formInfo = response.body.items[0].elements.contact_form.value[0];
					this.pageSuperbowl = response.body.items[0];
					this.modularContent = response.body.modular_content;
					this.contactFormInfo = response.body.modular_content[formInfo].elements;

					let sliders = this.pageSuperbowl.elements.slider.value;
					if (sliders.length) {
						for (var slider in sliders) {
							if (this.modularContent.hasOwnProperty(sliders[slider])) {
								this.sliders.push(this.modularContent[sliders[slider]].elements);
							}
						}
					}
					
					// Show footer after loading data
					setTimeout(function () {
						$("#footer").show();
					}, 500);
				});
			}
		},
		computed: {
			version: function(){
				return 'v2';
			}
		},
		components:{
			'hero':hero,
			'Footer':Footer,
			'contact': contactForm,
			'slider':slider,
		},
		mixins:[seoModule]
	}
</script>



// WEBPACK FOOTER //
// Dexcom.vue?6211490f